const { FILTERS_IDS } = require('@pages/V2/utils/constants');

const { PROMOTION_TYPE, CATEGORY, PRICE } = FILTERS_IDS;

const MLA = {
  title: 'Ofertas | Mercadolibre Argentina',
  selectorsMenu: {
    title: 'Ofertas',
    subtitle: '¡Encontrá precios increíbles cada día!',
  },
  smartGroupLinkText: 'Conoce más',
  filters: {
    [PROMOTION_TYPE]: 'Todas',
    [CATEGORY]: 'Todas las categorías',
    [PRICE]: 'Todos los rangos',
    filterBy: 'Filtrar por:',
    categoriesBreadcrumbDefault: 'Ofertas',
    allCategories: 'Todas',
    product: 'producto',
    shipping: 'Con tu carrito de compras',
    shippingTitle: 'te ahorra envíos',
    installments: 'En cuotas sin interés',
    shippingTime: 'Llega hoy',
    shippingCost: 'Gratis',
  },
  advertising: {
    title: 'Publicidad',
  },
};

const MLB = {
  title: 'Ofertas do dia | Mercadolivre Brasil',
  selectorsMenu: {
    title: 'Ofertas do dia',
    subtitle: 'Aproveite esses preços agora mesmo! Novas ofertas todos os dias.',
  },
  smartGroupLinkText: 'Conheça mais',
  filters: {
    [PROMOTION_TYPE]: 'Todas as ofertas',
    [CATEGORY]: 'Todas as categorias',
    [PRICE]: 'Todos os intervalos',
    filterBy: 'Filtrar por:',
    categoriesBreadcrumbDefault: 'Ofertas do dia',
    allCategories: 'Todas',
    product: 'produto',
    shipping: 'Em carrinhos de compras',
    shippingTitle: 'economiza frete',
    installments: 'Parcelamento sem juros',
    shippingTime: 'Chega hoje',
    shippingCost: 'Grátis',
  },
  advertising: {
    title: 'Publicidade',
  },
};

const MLU = {
  title: 'Ofertas | Mercadolibre Uruguay',
  selectorsMenu: {
    title: 'Ofertas',
    subtitle: '¡Encontrá precios increíbles cada día!',
  },
  smartGroupLinkText: 'Conocé más',
  filters: {
    [PROMOTION_TYPE]: 'Todas',
    [CATEGORY]: 'Todas las categorías',
    [PRICE]: 'Todos los rangos',
    filterBy: 'Filtrar por:',
    categoriesBreadcrumbDefault: 'Ofertas',
    allCategories: 'Todas',
    product: 'producto',
    shipping: 'Con tu carrito de compras',
    shippingTitle: 'te ahorra envíos',
    installments: 'En cuotas sin interés',
    shippingTime: 'Llega hoy',
    shippingCost: 'Gratis',
  },
  advertising: {
    title: 'Publicidad',
  },
};

const MCO = {
  title: 'Ofertas | Mercadolibre Colombia',
  smartGroupLinkText: 'Conoce más',
  selectorsMenu: {
    title: 'Ofertas',
    subtitle: '¡Encuentra precios increíbles cada día!',
  },
  filters: {
    [PROMOTION_TYPE]: 'Todas',
    [CATEGORY]: 'Todas las categorías',
    [PRICE]: 'Todos los rangos',
    filterBy: 'Filtrar por:',
    categoriesBreadcrumbDefault: 'Ofertas',
    allCategories: 'Todas',
    product: 'producto',
    shipping: 'Con tu carrito de compras',
    shippingTitle: 'te ahorra envíos',
    installments: 'En cuotas sin interés',
    shippingTime: 'Llega hoy',
    shippingCost: 'Gratis',
  },
  advertising: {
    title: 'Publicidad',
  },
};

const MPE = {
  title: 'Ofertas | Mercadolibre Perú',
  smartGroupLinkText: 'Conoce más',
  selectorsMenu: {
    title: 'Ofertas',
    subtitle: '¡Encuentra precios increíbles cada día!',
  },
  filters: {
    [PROMOTION_TYPE]: 'Todas',
    [CATEGORY]: 'Todas las categorías',
    [PRICE]: 'Todos los rangos',
    filterBy: 'Filtrar por:',
    categoriesBreadcrumbDefault: 'Ofertas',
    allCategories: 'Todas',
    product: 'producto',
    shipping: 'Con tu carrito de compras',
    shippingTitle: 'te ahorra envíos',
    installments: 'En cuotas sin interés',
    shippingTime: 'Llega hoy',
    shippingCost: 'Gratis',
  },
  advertising: {
    title: 'Publicidad',
  },
};

const MLC = {
  title: 'Ofertas | Mercadolibre Chile',
  selectorsMenu: {
    title: 'Ofertas',
    subtitle: '¡Encuentra precios increíbles cada día!',
  },
  smartGroupLinkText: 'Conoce más',
  filters: {
    [PROMOTION_TYPE]: 'Todas',
    [CATEGORY]: 'Todas las categorías',
    [PRICE]: 'Todos los rangos',
    filterBy: 'Filtrar por:',
    categoriesBreadcrumbDefault: 'Ofertas',
    allCategories: 'Todas',
    product: 'producto',
    shipping: 'Con tu carrito de compras',
    shippingTitle: 'te ahorra envíos',
    installments: 'En cuotas sin interés',
    shippingTime: 'Llega hoy',
    shippingCost: 'Gratis',
  },
  advertising: {
    title: 'Publicidad',
  },
};

const MEC = {
  title: 'Ofertas | Mercadolibre Ecuador',
  smartGroupLinkText: 'Conoce más',
  selectorsMenu: {
    title: 'Ofertas',
    subtitle: '¡Encuentra precios increíbles cada día!',
  },
  filters: {
    [PROMOTION_TYPE]: 'Todas',
    [CATEGORY]: 'Todas las categorías',
    [PRICE]: 'Todos los rangos',
    filterBy: 'Filtrar por:',
    categoriesBreadcrumbDefault: 'Ofertas',
    allCategories: 'Todas',
    product: 'producto',
    shipping: 'Con tu carrito de compras',
    shippingTitle: 'te ahorra envíos',
    installments: 'En cuotas sin interés',
    shippingTime: 'Llega hoy',
    shippingCost: 'Gratis',
  },
  advertising: {
    title: 'Publicidad',
  },
};

const MLM = {
  title: 'Ofertas | Mercadolibre México',
  selectorsMenu: {
    title: 'Ofertas',
    subtitle: '¡Encuentra precios increíbles cada día!',
  },
  smartGroupLinkText: 'Conoce más',
  filters: {
    [PROMOTION_TYPE]: 'Todas',
    [CATEGORY]: 'Todas las categorías',
    [PRICE]: 'Todos los rangos',
    filterBy: 'Filtrar por:',
    categoriesBreadcrumbDefault: 'Ofertas',
    allCategories: 'Todas',
    product: 'producto',
    shipping: 'Con tu carrito de compras',
    shippingTitle: 'te ahorra envíos',
    installments: 'En cuotas sin interés',
    shippingTime: 'Llega hoy',
    shippingCost: 'Gratis',
  },
  advertising: {
    title: 'Publicidad',
  },
};

const MLV = {
  title: 'Ofertas | Mercadolibre Venezuela',
  selectorsMenu: {
    title: 'Ofertas',
    subtitle: '¡Encuentra precios increíbles cada día!',
  },
  smartGroupLinkText: 'Conoce más',
  filters: {
    [PROMOTION_TYPE]: 'Todas',
    [CATEGORY]: 'Todas las categorías',
    [PRICE]: 'Todos los rangos',
    filterBy: 'Filtrar por:',
    categoriesBreadcrumbDefault: 'Ofertas',
    allCategories: 'Todas',
    product: 'producto',
    shipping: 'Con tu carrito de compras',
    shippingTitle: 'te ahorra envíos',
    shippingTime: 'Llega hoy',
    installments: 'En cuotas sin interés',
    shippingCost: 'Gratis',
  },
  advertising: {
    title: 'Publicidad',
  },
};

const translations = {
  MLA,
  MLB,
  MLU,
  MCO,
  MPE,
  MLC,
  MEC,
  MLM,
  MLV,
};

export const getTranslationsBySite = (siteId = 'MCO') => {
  return translations[siteId];
};
